class LogoSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const slider = this.querySelector('.logo-slider-swiper');

      if (!slider) return;

      new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 16,
        loop: true,

        pagination: {
          el: this.querySelector('.logo-slider-pagination'),
          clickable: true,
        },

        breakpoints: {
          0: {
            slidesPerView: 2,
            centeredSlides: true,
            spaceBetween: 0,
          },
          540: {
            slidesPerView: 3,
            centeredSlides: true,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false ,
          },
          990: {
            slidesPerView: 5,
            spaceBetween: 32,
          }
        }
      });
    }
  }

  customElements.define('logo-slider', LogoSlider);